<main>
    <div class="container-fluid background-image">
        <div class="row center-align">
            <div>
                <div class="m-5">
                    <div>
                        <div class="h5 section-heading">Property Matrix Admin Portal</div>
                        <p class="paragraph section-content">Welcome to the Team. The Network. The Matrix.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>